// © Microsoft Corporation. All rights reserved.

import { open_outside, plus, trash } from "../../utils/icons";

import React from "react";
import { Resource } from "@msnews/social-data-service";
import { SocialClassNameContract } from "../../Social.classnames";
import { SocialLocalizedStrings } from "../../Social.localizedStrings";

interface MediaInputProps{
    className?: string,
    managedClasses?: SocialClassNameContract;
    placeholder?: string;
    onChange: (files) => void;
    onRemove: (id: string) => void;
    onSetCover: (id: string) => void;
    resources?: Array<Resource>;
    t?: SocialLocalizedStrings;
}

interface MediaInputState{
    files: object[];
    previewUrls: string[];
}

export default class MediaInput extends React.Component<MediaInputProps, MediaInputState> {
    containerRef: React.RefObject<HTMLDivElement>;
    inputRef: React.RefObject<HTMLInputElement>;

    constructor(props) {
        super(props);
        this.containerRef = React.createRef<HTMLDivElement>();
        this.inputRef = React.createRef<HTMLInputElement>();

        this.state = {
            files: [],
            previewUrls: []
        };
    }

    removeItem(id: string) {
        if (this.props.onRemove) { this.props.onRemove(id); }
    }

    setCoverItem(id: string) {
        if (this.props.onSetCover) { this.props.onSetCover(id); }
    }

    fileSelectHandler(event) {
        if (this.props.onChange && event && event.target && event.target.files && event.target.files.length > 0) { this.props.onChange(event.target.files); }
    }

    renderImage(url: string, id: string) {
        return (
            <div key={id}  className="cwt-image-container">
                <img src={url} alt="" className="cwt-image"/>
                <div className="cwt-button-container">
                    <i className="cwt-icon cwt-setcover-btn" title="Set as cover" onClick={this.setCoverItem.bind(this, id)}> {open_outside} </i>
                    <i className="cwt-icon cwt-close-btn" title="Remove item" onClick={this.removeItem.bind(this, id)}> {trash} </i>
                </div>
            </div>
        );
    }

    render() {
        const { className, managedClasses, resources, t} = this.props;

        return (
            <div className={`${managedClasses.mediaInputContainer} ${className}`} ref={this.containerRef}>
                {this.state.files.length < 1 &&
          <i className="cwt-icon cwt-add-image-icon">
              {plus}
              <span className="cwt-icon-label">{t.MediaInputAddMedia}</span>
          </i>
                }

                <div className="cwt-media-container">
                    {resources && resources.map((resource) => this.renderImage(resource.url, resource.id))}
                </div>

                <input
                    multiple
                    ref={this.inputRef}
                    className="cwt-media-input"
                    type="file"
                    onChange={this.fileSelectHandler.bind(this)}
                    onDrop={this.fileSelectHandler.bind(this)}
                />
            </div>
        );
    }
}
